import { Document, Font, Image, Page, StyleSheet } from '@react-pdf/renderer';
import { OrderType } from '../../../interfaces/delivery-company/orders';
import { PageFooter } from '../pdf-builders-utils/page-footer';
import { ReportTable } from './table';
import { pageStyles } from '../pdf-builders-utils/styles';
import { PageTitle } from '../pdf-builders-utils/page-title';
import { useEffect, useState } from 'react';
import { IOrderDeliveryTask, IPickupTask } from '../../../interfaces/delivery-company/tasks';

export interface IFieldConfig<T extends OrderType | IPickupTask | IOrderDeliveryTask> {
  display_name: string[];
  width_percentage: string;
  get_values: (item: T) => string[];
  get_aggregate?: (items: T[]) => string[];
}

export interface IFooterRow<T extends OrderType | IPickupTask | IOrderDeliveryTask> {
  label: string;
  compute_value: (items: T[]) => string;
}

export interface Table<T extends OrderType | IPickupTask | IOrderDeliveryTask> {
  fields_config: IFieldConfig<T>[];
  title: string;
  header_bg: string;
  items: T[];
  table_footer_rows: IFooterRow<T>[];
}

export interface ReportProps<T extends OrderType | IPickupTask | IOrderDeliveryTask> {
  tables: Table<T>[];
  organisation_id: string;
  date_from: string;
  date_to: string;
  title: string;
  subtitles?: string[];
  color: string;
}

export function ReportDocument<T extends OrderType | IPickupTask | IOrderDeliveryTask>(reportProps: ReportProps<T>) {
  console.log("tables = ", reportProps.tables)
  return (
    <Document>
      <Page size="A4" style={pageStyles.page} wrap={true}>
        <Image
          style={pageStyles.logo}
          src={`https://parcel-tracer-public.s3.eu-central-1.amazonaws.com/${reportProps.organisation_id}/logo.png?v=${new Date().getTime()}`}
        />
        <PageTitle {...reportProps} />
        {reportProps.tables.map((table, index) => (
          <ReportTable<T>
            key={index}
            index={index}
            table_footer_rows={table.table_footer_rows}
            on_new_page={index > 0}
            items={table.items}
            fields_config={table.fields_config}
            title={table.title}
            header_bg={table.header_bg}
            color={reportProps.color}
          />
        ))}
        <PageFooter color={reportProps.color} />
      </Page>
    </Document>
  );
}

interface MultiReportDocumentProps<T extends OrderType | IPickupTask | IOrderDeliveryTask> {
  reportsProps: ReportProps<T>[]
}
export function MultiReportDocument<T extends OrderType | IPickupTask | IOrderDeliveryTask>({ reportsProps }: MultiReportDocumentProps<T>) {
  return <Document>{reportsProps.map((reportProps, index) => <Page key={index} size="A4" style={pageStyles.page} wrap={true}>
    <Image
      style={pageStyles.logo}
      src={`https://parcel-tracer-public.s3.eu-central-1.amazonaws.com/${reportProps.organisation_id}/logo.png?v=${new Date().getTime()}`}
    />
    <PageTitle {...reportProps} />
    {reportProps.tables.map((table, index) => (
      <ReportTable<T>
        key={index}
        index={index}
        table_footer_rows={table.table_footer_rows}
        on_new_page={index > 0}
        items={table.items}
        fields_config={table.fields_config}
        title={table.title}
        header_bg={table.header_bg}
        color={reportProps.color}
      />
    ))}
    <PageFooter color={reportProps.color} />
  </Page>)}</Document>
}